import { SyntheticEvent } from 'react';
import TextField from '@mui/material/TextField';

import BatchList from '#components/BatchList';

type BatchRow = Record<string, string>;

interface BatchListError {
  rowIndex: number;
  [field: string]: unknown;
}

interface VideoListProps {
  name?: string;
  value: BatchRow[];
  onChange: (event: SyntheticEvent, change: { name?: string | undefined; value: BatchRow[] }) => void;
  sizes: number[];
  errors?: BatchListError[];
}

export default function VideoList(props: VideoListProps) {
  const {
    name,
    value,
    onChange,
    sizes,
    errors,
  } = props;

  return (
    <BatchList
      items={value}
      name={name}
      onChange={onChange}
      sizes={sizes}
      errors={errors}
    >
      <TextField
        fullWidth
        data-testid="video-list-url"
        size="small"
        name="url"
        label="YouTube or YouTube Shorts Url"
        variant="outlined"
      />
    </BatchList>
  );
}
